// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610151655/js/" + chunkId + "." + {"44":"8ae6e2b8","225":"aecfd0cc","481":"2304fd76","486":"99a9411b","770":"68fc3b46"}[chunkId] + ".0.2659665176875706.chunk.js";
};